import { Link, Typography } from '@mui/material';
import React, { FC } from 'react';
import { BlACK_TEXT } from 'utils/styles/colors';
import zoomSdk from '@zoom/appssdk';
import { Box } from '@mui/system';

const FccDisclaimer: FC = () => {
  const urls = {
    sorenson: 'https://sorenson.com/solutions/video-relay-services',
    mailto: `${process.env.REACT_APP_API_BASE_URL}/zoomapp/mailto?to=mailto:support@sorenson.com`,
  };
  const handleOpenUrl = (url: string) => {
    zoomSdk.openUrl({ url });
  };

  return (
    <Box id='fcc-disclaimer'>
      <hr
        style={{
          border: 'none',
          margin: '0px 0px 16px 0px',
          width: '100%',
          height: '1px',
          backgroundColor: `var(--stroke-separator, rgba(4, 8, 9, 0.05)`,
        }}
      />
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: '400',
          color: BlACK_TEXT,
          opacity: '75%',
          marginBottom: '16px',
          '& a': {
            color: BlACK_TEXT,
            opacity: '75%',
            textDecorationColor: BlACK_TEXT,
            textDecoration: 'underline',
          },
        }}
      >
        (If you don’t have a Sorenson VRS account, you can apply now at{' '}
        <Link
          id='vrs-account-apply-link'
          sx={{
            color: BlACK_TEXT,
            opacity: '75%',
            textDecoration: 'underline',
            fontSize: '12px',
            cursor: 'pointer',
          }}
          onClick={() => handleOpenUrl(urls.sorenson)}
        >
          https://sorenson.com/solutions/video-relay-services.
        </Link>
        ){' '}
      </Typography>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: '400',
          marginBottom: '16px',
          color: BlACK_TEXT,
        }}
      >
        This application for connecting to video conferencing services is in
        development and its features and functions may change as development
        continues. At this time, this application allows connections with only
        Zoom and not to all video conferencing services.
      </Typography>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: '400',
          marginBottom: '16px',
          color: BlACK_TEXT,
          '& a': {
            color: BlACK_TEXT,
            textDecorationColor: BlACK_TEXT,
            textDecoration: 'underline',
          },
        }}
      >
        Consumers should contact a Sorenson representative at (866) 756-6729 or
        <Link
          id='sorenson-support-email'
          sx={{
            color: BlACK_TEXT,
            fontSize: '12px',
            marginBottom: '16px',
            cursor: 'pointer',
          }}
          onClick={() => handleOpenUrl(urls.mailto)}
        >
          {' '}
          support@sorenson.com
        </Link>{' '}
        if they cannot connect to a Zoom video conference with the application
        or if the application fails during a Zoom video conference after an
        initial connection.
      </Typography>
    </Box>
  );
};
export default FccDisclaimer;
